import { combineReducers } from "redux";
import dataReducer from "./dataReducer";
import checkRowReducer from "./checkRowReducer";

const reducers = combineReducers({
    listData: dataReducer,
    rowIds: checkRowReducer
});

export default reducers;